import './OrderBar.css';
import {useEffect, useState} from "react";
import {useMediaQuery} from "react-responsive";

const financialStatusMap = {
    AUTHORIZED: "Autoryzowano",
    EXPIRED: "Wygasło",
    PAID: "Opłacono",
    PARTIALLY_PAID: "Częściowo opłacono",
    PARTIALLY_REFUNDED: "Częściowo zwrócono",
    PENDING: "Oczekuje na płatność",
    REFUNDED: "Zwrócono",
    VOIDED: "Anulowano"
};

export default function OrderBar({order, setOrderToDisplay}) {
    const isMobile = useMediaQuery({maxWidth: 768});
    const [imageAmount, setImageAmount] = useState(4);
    useEffect(() => {
        setImageAmount(isMobile ? 2 : 4);
    },[isMobile]);

    return <div className="order-bar" onClick={() => setOrderToDisplay(order.orderID)}>
        <div className="order-bar-left">
            <span className="order-bar-status">{financialStatusMap[order.status]}</span>
            <div className="order-bar-wrapper">
                <span className="order-bar-date">{order.date}</span>
                <span className="order-bar-id">{order.orderID}</span>
            </div>
            <span className="order-bar-price">{order.totalPrice} zł</span>
        </div>
        <div className="order-bar-right">
            {order.items.map((item, index) => {
                return index < imageAmount ? <div className='order-bar-image-square' key={index}

                ><img src={item.url} alt={item.alt ? item.alt : "Obrazek przedmiotu"}/></div> : null


            })}
            {order.items.length > imageAmount ? <div className='order-bar-item-extend'>
                <span className="order-bar-extend-text">
                    +{order.items.length - imageAmount}
                </span>
            </div> : null}
        </div>
    </div>;
}
